// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__W4g7p","mainWrapper":"Logo_mainWrapper__kKLpv"};